import axios from "axios";

const baseUrl = process.env.REACT_APP_BASE_URL_V1;

export const sendOtp = async (phone) => {
  const formData = new URLSearchParams();
  formData.append('phone_number', phone);
  return await axios.post(`${baseUrl}otp/send`, formData, {
    headers: { "Content-Type": "application/x-www-form-urlencoded" }
  });
};

export const verifyOtp = async ({ phone, otp,user_uuid }) => {
  const formData = new URLSearchParams();
  formData.append('phone_number', phone);
  formData.append('otp', otp);
  formData.append('user_uuid', user_uuid);
  return await axios.post(`${baseUrl}otp/verify`, formData, {
    headers: { "Content-Type": "application/x-www-form-urlencoded" }
  });
};

